interface Identifier {
  facebook: RegExp,
  instagram: RegExp,
  line: RegExp,
  messenger: RegExp,
  miui: RegExp,
  puffin: RegExp,
  twitter: RegExp,
  wechat: RegExp,
}

const IDENTIFIERS: Identifier = {
  facebook: /\bFB[\w_]+\//,
  instagram: /\bInstagram/i,
  line: /\bLine\//i,
  // not working
  messenger: /\bFB[\w_]+\/(Messenger|MESSENGER)/,
  miui: /\bMiuiBrowser\//i,
  puffin: /\bPuffin/i,
  twitter: /\bTwitter/i,
  wechat: /\bMicroMessenger\//i,
}

/**
 *
 * @param userAgent window.navigator.userAgent
 * @param target
 */
function isInAppBrowser(userAgent: string, target?: keyof Identifier): boolean {
  if(!userAgent) {
    return false
  }
  
  if(target) {
    return IDENTIFIERS[target].test(userAgent)
  }
  
  return Boolean(
    Object.entries(IDENTIFIERS).find((value) => {
      return value[1].test(userAgent)
    }),
  )
}

export default isInAppBrowser
